// @core/api/endpoints/userprofile/delete_avatars_bulk.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeleteAvatarsBulkResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Delete multiple avatars
 * Deletes multiple avatars in a single request. Returns results indicating which deletions succeeded and which failed.
 */
export async function DeleteAvatarsBulk(
  options?: RequestOptions
): Promise<DeleteAvatarsBulkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/avatars/bulk`;
  const requestOptions = options;
  return client.delete<DeleteAvatarsBulkResponse>(requestPath, requestOptions);
}
